var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFootMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3384_6211)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 25,
    height: 25,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.125,
    y: 0.125,
    width: 24.75,
    height: 24.75,
    rx: 1.875,
    stroke: "black",
    strokeWidth: 0.25
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4286 8H19.1429C19.3702 8 19.5882 8.0878 19.7489 8.24408C19.9097 8.40036 20 8.61232 20 8.83333C20 9.05435 19.9097 9.26631 19.7489 9.42259C19.5882 9.57887 19.3702 9.66667 19.1429 9.66667H11.4286C11.2012 9.66667 10.9832 9.57887 10.8225 9.42259C10.6617 9.26631 10.5714 9.05435 10.5714 8.83333C10.5714 8.61232 10.6617 8.40036 10.8225 8.24408C10.9832 8.0878 11.2012 8 11.4286 8ZM11.4286 12.1667H19.1429C19.3702 12.1667 19.5882 12.2545 19.7489 12.4107C19.9097 12.567 20 12.779 20 13C20 13.221 19.9097 13.433 19.7489 13.5893C19.5882 13.7455 19.3702 13.8333 19.1429 13.8333H11.4286C11.2012 13.8333 10.9832 13.7455 10.8225 13.5893C10.6617 13.433 10.5714 13.221 10.5714 13C10.5714 12.779 10.6617 12.567 10.8225 12.4107C10.9832 12.2545 11.2012 12.1667 11.4286 12.1667ZM11.4286 16.3333H19.1429C19.3702 16.3333 19.5882 16.4211 19.7489 16.5774C19.9097 16.7337 20 16.9457 20 17.1667C20 17.3877 19.9097 17.5996 19.7489 17.7559C19.5882 17.9122 19.3702 18 19.1429 18H11.4286C11.2012 18 10.9832 17.9122 10.8225 17.7559C10.6617 17.5996 10.5714 17.3877 10.5714 17.1667C10.5714 16.9457 10.6617 16.7337 10.8225 16.5774C10.9832 16.4211 11.2012 16.3333 11.4286 16.3333ZM8.85714 8C9.02667 8 9.19239 8.04887 9.33335 8.14044C9.4743 8.23201 9.58416 8.36216 9.64904 8.51443C9.71391 8.6667 9.73089 8.83426 9.69782 8.99591C9.66474 9.15756 9.58311 9.30605 9.46323 9.42259C9.34336 9.53913 9.19063 9.6185 9.02436 9.65065C8.85809 9.68281 8.68575 9.6663 8.52913 9.60323C8.37251 9.54016 8.23864 9.43335 8.14445 9.29631C8.05027 9.15927 8 8.99815 8 8.83333C8 8.61232 8.09031 8.40036 8.25105 8.24408C8.4118 8.0878 8.62981 8 8.85714 8ZM8.85714 12.1667C9.02667 12.1667 9.19239 12.2155 9.33335 12.3071C9.4743 12.3987 9.58416 12.5288 9.64904 12.6811C9.71391 12.8334 9.73089 13.0009 9.69782 13.1626C9.66474 13.3242 9.58311 13.4727 9.46323 13.5893C9.34336 13.7058 9.19063 13.7852 9.02436 13.8173C8.85809 13.8495 8.68575 13.833 8.52913 13.7699C8.37251 13.7068 8.23864 13.6 8.14445 13.463C8.05027 13.3259 8 13.1648 8 13C8 12.779 8.09031 12.567 8.25105 12.4107C8.4118 12.2545 8.62981 12.1667 8.85714 12.1667ZM8.85714 16.3333C9.02667 16.3333 9.19239 16.3822 9.33335 16.4738C9.4743 16.5653 9.58416 16.6955 9.64904 16.8478C9.71391 17 9.73089 17.1676 9.69782 17.3292C9.66474 17.4909 9.58311 17.6394 9.46323 17.7559C9.34336 17.8725 9.19063 17.9518 9.02436 17.984C8.85809 18.0161 8.68575 17.9996 8.52913 17.9366C8.37251 17.8735 8.23864 17.7667 8.14445 17.6296C8.05027 17.4926 8 17.3315 8 17.1667C8 16.9457 8.09031 16.7337 8.25105 16.5774C8.4118 16.4211 8.62981 16.3333 8.85714 16.3333Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3384_6211",
    x: 0,
    y: 0,
    width: 27,
    height: 27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3384_6211"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3384_6211",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootMenuIcon);
export default __webpack_public_path__ + "static/media/Foot-menu-icon.f0c9ce82c0f334b4f74023d4a70e8bd4.svg";
export { ForwardRef as ReactComponent };